import { routes as feriados } from './feriado';
import { routes as paralisacoes } from './paralisacao';
import { routes as calatividade } from './atividade';
import { routes as atividadesMes } from './atividadesMes';
import { routes as calendario } from './calcalendario';
import { routes as agenda } from './agenda';

export default [
  {
    path: '/calendario',
    name: 'Calendário',
    description: 'Módulo Calendário',
    children: [
      ...feriados,
      ...paralisacoes,
      ...calatividade,
      ...atividadesMes,
      ...calendario,
      ...agenda,
    ],
    goesToMenu: true,
  },
];
